<div class="modal-header">
  <h2 mat-dialog-title class="modal-title">Reset Password</h2>
  <button class="modal-close-btn" mat-icon-button (click)="closeModal()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="stepper-container">
  <div
    class="step"
    [class.done]="step === 'verify' || step === 'success'"
    [class.current]="step === 'initial'"
  >
    <div class="step-circle">
      <mat-icon *ngIf="step === 'verify' || step === 'success'">check</mat-icon>
      <span *ngIf="step === 'initial'">1</span>
    </div>
    <div class="step-label">Identify</div>
  </div>
  <div class="step-connector" [class.active]="step === 'verify' || step === 'success'"></div>
  <div class="step" [class.done]="step === 'success'" [class.current]="step === 'verify'">
    <div class="step-circle">
      <mat-icon *ngIf="step === 'success'">check</mat-icon>
      <span *ngIf="step !== 'success'">2</span>
    </div>
    <div class="step-label">Verify &amp; Reset</div>
  </div>
  <div class="step-connector" [class.active]="step === 'success'"></div>
  <div class="step" [class.current]="step === 'success'">
    <div class="step-circle">
      <mat-icon>check</mat-icon>
    </div>
    <div class="step-label">Done</div>
  </div>
</div>

<mat-dialog-content class="modal-content-body">
  <div *ngIf="step === 'initial'" [@stepAnimation] class="step-content">
    <p class="modal-subtitle">
      Enter your username and we'll send a verification code to your registered mobile device.
    </p>
    <div class="login-form-row">
      <input
        class="login-form-field focusOnParent"
        type="text"
        placeholder="Username"
        aria-label="username"
        [(ngModel)]="username"
        (keyup.enter)="requestPasswordReset()"
      />
      <i class="login-form-icon icon-userName"></i>
    </div>
  </div>

  <div *ngIf="step === 'verify'" [@stepAnimation] class="step-content">
    <div class="password-requirements">
      <p>Your new password must contain:</p>
      <ul>
        <li>At least 8 characters</li>
        <li>At least one capital letter (A-Z)</li>
        <li>At least one special character (!&#64;#$%)</li>
      </ul>
    </div>
    <p class="modal-subtitle">
      A verification code has been sent. Please enter the code and your new password below.
    </p>
    <!-- This is Hidden,Only for Chrome to save the actual username -->
    <input
      type="text"
      name="username"
      autocomplete="username"
      [value]="username"
      style="display: none"
    />

    <div class="login-form-row">
      <input
        class="login-form-field"
        type="text"
        placeholder="Verification Code"
        aria-label="verification code"
        [(ngModel)]="code"
        (keyup.enter)="submitNewPassword()"
      />
      <i class="login-form-icon icon-code"></i>
    </div>

    <div class="login-form-row">
      <input
        class="login-form-field"
        [type]="hidePassword ? 'password' : 'text'"
        placeholder="New Password"
        aria-label="new password"
        [(ngModel)]="newPassword"
        (keyup.enter)="submitNewPassword()"
      />
      <i
        class="login-form-icon"
        [class.icon-openpw]="!hidePassword"
        [class.icon-closepw]="hidePassword"
        (click)="hidePassword = !hidePassword"
      ></i>
    </div>

    <div class="login-form-row">
      <input
        class="login-form-field"
        [type]="hideConfirmPassword ? 'password' : 'text'"
        placeholder="Confirm New Password"
        aria-label="confirm new password"
        [(ngModel)]="confirmPassword"
        (keyup.enter)="submitNewPassword()"
      />
      <i
        class="login-form-icon"
        [class.icon-openpw]="!hideConfirmPassword"
        [class.icon-closepw]="hideConfirmPassword"
        (click)="hideConfirmPassword = !hideConfirmPassword"
      ></i>
    </div>
  </div>

  <div *ngIf="step === 'success'" [@stepAnimation] class="step-content">
    <div class="modal-feedback">
      <p class="modal-subtitle">
        Your password has been reset successfully. You can now close this window and log in.
      </p>
    </div>
  </div>

  <div *ngIf="errorMessage" class="modal-error">{{ errorMessage }}</div>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button
    *ngIf="step === 'initial'"
    class="modal-submit t-btn-grad"
    (click)="requestPasswordReset()"
    [disabled]="isLoading"
  >
    <span class="button-text" [class.hidden]="isLoading">Send Verification Code</span>
    <mat-spinner *ngIf="isLoading" class="button-spinner" [diameter]="24"></mat-spinner>
  </button>

  <button
    *ngIf="step === 'verify'"
    class="modal-submit t-btn-grad"
    (click)="submitNewPassword()"
    [disabled]="isLoading"
  >
    <span class="button-text" [class.hidden]="isLoading">Reset Password</span>
    <mat-spinner *ngIf="isLoading" class="button-spinner" [diameter]="24"></mat-spinner>
  </button>

  <button *ngIf="step === 'success'" class="modal-submit t-btn-grad" (click)="closeModal()">
    Close
  </button>
</mat-dialog-actions>
